import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=cb4d235a&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=cb4d235a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4d235a",
  null
  
)

export default component.exports